import type { AddressData, OrderStatus } from "@/features/dmManagement/types";

/** ステータス遷移が発生しない確定済みステータス */
export const TERMINAL_ORDER_STATUSES: ReadonlySet<OrderStatus> = new Set([
  "dispatched",
  "cancelled",
  "failed",
]);

/** 宛先リストファイルの最大サイズ (5MB) */
export const ADDRESS_LIST_MAX_FILE_SIZE = 5 * 1024 * 1024;

/** 宛先リストファイルの許可拡張子 */
export const ADDRESS_LIST_ALLOWED_EXTENSIONS = ["csv", "xlsx"];

/** デザインPDFファイルの最大サイズ (2GB) */
export const DESIGN_PDF_MAX_FILE_SIZE = 2 * 1024 * 1024 * 1024;

/** デザインステータスのフィルター選択肢 */
export const DESIGN_STATUS_OPTIONS = [
  { value: "", label: "全て" },
  { value: "submitted", label: "申請中" },
  { value: "approved", label: "承認済み" },
  { value: "rejected", label: "却下" },
] as const;

/** 注文ステータスのフィルター選択肢 */
export const ORDER_STATUS_OPTIONS = [
  { value: "", label: "全て" },
  { value: "submitted", label: "注文済み" },
  { value: "processing", label: "処理中" },
  { value: "action_required", label: "要対応" },
  { value: "printing", label: "印刷中" },
  { value: "dispatched", label: "発送済み" },
  { value: "cancelled", label: "キャンセル" },
  { value: "failed", label: "失敗" },
] as const;

export const ADDRESS_DATA_COLUMNS: Record<keyof AddressData, string> = {
  number: "番号",
  postalCode: "郵便番号",
  companyName: "企業名",
  branchDepartment: "支店/部署",
  titleDepartment: "役職/部署",
  name: "名前",
  honorific: "敬称",
  address1: "住所1",
  address2: "住所2",
  remarks: "備考",
};
